module.exports = __webpack_public_path__ + "img/xcx-sht.14e770c5.png";